<template>
    <FormModal :model="model" :init="init" modal-id="shipping_address">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label="保存名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.name"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.name" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="タイプ"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <vue-select
                        v-model="model.type"
                        :options="$store.state.app.data.shipping_addresses_type || []"
                        label="name"
                        size="sm"
                        :reduce="v => v.value"
                        >
                    </vue-select>
                    <b-form-checkbox
                        v-model="model.is_default"
                        :value="1"
                        :unchecked-value="0"
                        >
                        初期値として利用する
                    </b-form-checkbox>
                    <input-error :errors="error.type" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="住所"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-table-simple>
                        <AddressContent
                            v-model="model"
                            :prefixes="[ '', ]"
                            :error="error"
                            :fields="fields()"
                            />
                    </b-table-simple>
                </b-form-group>
            </template>
            <template v-else>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import AddressContent from '@/components/AddressContent.vue'

export default {
    components: {
        FormModal,
        AddressContent,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
        fields () {
console.log(this.model.type)
            switch (this.model.type) {
                case 'from':
                    return {
                        representative: true,
                        company: false,
                        line1: true,
                        line2: false,
                        city: true,
                        state: true,
                        zip: true,
                        country: true,
                        tel: true,
                        email: true,
                        tax_id: false,
                        vat_id: false,
                        eori: false,
                    }
                case 'to':
                case 'importer':
                    return {
                        representative: true,
                        company: false,
                        line1: true,
                        line2: false,
                        city: true,
                        state: true,
                        zip: true,
                        country: true,
                        tel: true,
                        email: false,
                        tax_id: false,
                        vat_id: false,
                        eori: false,
                    }
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>


